import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import eyebox from "../../Utils/Images/eyebox.png";
import DeleteModal from "../Modal/DeleteModal";
import { GetSubAdmins } from "../../APIs/Function/Controller/GetSubAdmin";
import { Link } from "react-router-dom";
import { handleDeleteSubadmin } from "../../APIs/Function/Controller/DeleteSubAdmin";
import Loader from "../Loader/Loader";

const ControllerTable = ({
  Column1,
  Column2,
  column3,
  Column4,
  data,
  setData,
  loading,
  setLoading,
}) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteSubadmin(modalID);
    setOpen(false);
    let res = await GetSubAdmins();
    setLoading(false);
    setData(res.r);
    alert("SubAdmin Deleted");
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          <Box>
            {/* table heading */}
            <Box
              sx={{
                boxShadow: "none",
                outline: "none",
                mb: "10px",
                border: "none",
                mt: "30px",
                boxSizing: "border-box",
              }}
            >
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      {Column1}
                    </Typography>
                  </Paper>
                </Grid>

                {/* Second Column */}

                <Grid item xs={4.5} md={4.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      {Column2}
                    </Typography>
                  </Paper>
                </Grid>

                {/* Third Column */}

                <Grid item xs={5} md={5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      {column3}
                    </Typography>
                  </Paper>
                </Grid>

                {/* Fourth Column */}

                <Grid item xs={2} md={2}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      {Column4}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            {/* table data */}
            <Box
              sx={{ border: "0.5px solid #DDDDDD",
                overflow: "auto",
                minHeight: "100px",
                maxHeight: "415px",
                "&:hover": {
                  "::-webkit-scrollbar": {
                    width: "5px",
                    borderRadius: "10px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    bgcolor: "gray",
                    borderRadius: "10px",
                  },
                },
              }}
            >
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  {data.map((e, i) => (
                    <Paper
                      key={i}
                      sx={{
                        borderRadius: "0px",
                        border: "0.5px solid #DDDDDD",
                        boxShadow: "none",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {i + 1}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>

                {/* Second Column */}

                <Grid item xs={4.5} md={4.5}>
                  {data.map((e, i) => (
                    <Paper
                      key={i}
                      sx={{
                        borderRadius: "0px",
                        border: "0.5px solid #DDDDDD",
                        boxShadow: "none",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",

                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "100%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {e.email}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>

                {/* Third Column */}

                <Grid item xs={5} md={5}>
                  {data.map((e, i) => (
                    <Paper
                      key={i}
                      sx={{
                        borderRadius: "0px",
                        border: "0.5px solid #DDDDDD",
                        boxShadow: "none",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",

                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "100%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {e.privileges.trim("").split(",").length}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>

                {/* Fourth Column */}
                <Grid item xs={2} md={2}>
                  {data.map((e, i) => (
                    <Paper
                      key={i}
                      sx={{
                        borderRadius: "0px",
                        border: "0.5px solid #DDDDDD",
                        boxShadow: "none",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "Flex",
                          width: "100%",
                          gap: "20px",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            cursor: "pointer",
                            width: { xs: "50%", md: "40px" },
                            height: { xs: "50%", md: "40px" },
                          }}
                        >
                          <Link to={`/singlesubadmin/${e.id}`}>
                            <img
                              width={"100%"}
                              height={"100%"}
                              src={eyebox}
                              alt="logo"
                            />
                          </Link>
                        </Box>

                        <Box
                          sx={{
                            cursor: "pointer",
                            width: { xs: "50%", md: "40px" },
                            height: { xs: "50%", md: "40px" },
                          }}
                        >
                          {" "}
                          <Link to={`/editsubadmin/${e.id}`}>
                            <img
                              width={"100%"}
                              height={"100%"}
                              src={editbox}
                              alt="logo"
                            />
                          </Link>
                        </Box>

                        <Box
                          sx={{
                            cursor: "pointer",
                            width: { xs: "50%", md: "40px" },
                            height: { xs: "50%", md: "40px" },
                          }}
                        >
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={deletebox}
                            onClick={() => handleModal(e.id)}
                            alt=""
                          />
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Box>
          <DeleteModal
            open={open}
            handleDelete={handleDelete}
            modalID={modalID}
            onClose={handleClose}
          />
        </Box>
      )}
    </>
  );
};

export default ControllerTable;
